import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {JobHistory, JobHistoryEntry} from '../../monitoring.models';

// tslint:disable-next-line:no-empty-interface
export interface DialogData extends JobHistory {
}


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'view-job-history-dialog',
    templateUrl: 'view-job-history-dialog.html',
})
// tslint:disable-next-line:component-class-suffix
export class ViewJobHistoryDialog {
    progress = false;
    jobHistoryEntries: JobHistoryEntry[] = [];
    displayedColumns: string[] = ['createdAt', 'transactionDate', 'status'];

    constructor(
        public dialogRef: MatDialogRef<ViewJobHistoryDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        // public locationService: LocationService,
        private _snackBar: MatSnackBar) {
    }

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnInit() {
        if (this.data) {
            this.jobHistoryEntries = this.data.jobHistoryEntries || [];
            console.log(this.jobHistoryEntries);
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
